import React , { useState , useEffect } from 'react';
import { Link } from "react-router-dom";
import { Button } from 'reactstrap';

const Pagination = ({ onPageChange ,total_pages, current_page }) => {
const [page_value, setpage_value] = useState(0)
const [selected_page, setselected_page] = useState(current_page)
const onClickNext = () => {
    if(page_value+2 < total_pages){
     
    setpage_value(page_value+1)
    }
}


const onClickPrevious = () => {
   if(page_value !== 0){
    setpage_value(page_value-1)
   }
}


const page_Change=(page)=>{
    setselected_page(page)

    onPageChange(page)
}

useEffect(() => {
  
    setselected_page(current_page)
    if(current_page === 1){

        setpage_value(0)
    }
}, [current_page])




  return (
    <>
      <div className="d-flex justify-content-end">
            <div className="pagination-wrap hstack gap-2">
                <div onClick={onClickPrevious} className="page-item pagination-prev disabled" >
                    Previous
                </div>
                <ul className="pagination listjs-pagination mb-0">
                    <li onClick={()=>{
                        page_Change(page_value + 1)
                    }} class="page-item">
                        <a class={`page-link ${selected_page===(page_value+1)?'active':''}`} >{  page_value + 1}</a>
                    </li>
                    <li onClick={()=>{
                        page_Change(page_value + 2)
                    }} class="page-item">
                       { (page_value+2 <= total_pages) && <a class={`page-link ${selected_page===(page_value+2)?'active':''}`}>{ page_value+2}</a>}
                    </li>
                </ul>
                <div onClick={onClickNext} className="page-item pagination-next">
                    Next
                </div>
            </div>
        </div>
    </>
  )
}

export default Pagination
